export enum WishListEvent {
    GET_WISH_LIST_ITEMS = 'wishList:get',
    ARTICLE_TOGGLE = 'wishList:icon:toggle',
    LIST_UPDATE = 'wishList:update',
}
